import React from 'react';
import PropTypes from 'prop-types';

import get from 'utils/get';
import cx from 'classnames';
import slugify from 'utils/slugify';
import captionImageBlockModel from 'models/captionImageBlockModel';

import CaptionImageBlock from 'components/CaptionImageBlock';

const BlockImage = ({ block }) => {
  const fields = get(block, 'fields', {});
  const title = get(fields, 'title', '');
  const captionImage = get(fields, 'captionImage.fields', {});
  const paddingTop = slugify(get(fields, 'paddingTop', 'Large'));
  const paddingBottom = slugify(get(fields, 'paddingBottom', 'Large'));
  const showBlockTitle = get(fields, 'showBlockTitle', false);
  const imageSizeByHeight = get(captionImage, 'imageSizeByHeight');
  const imageSize = slugify(get(captionImage, 'imageSize', 'none'));
  const imageText = get(captionImage, 'text', '');
  const imageTextPosition = slugify(get(captionImage, 'textPosition', ''));

  return (
    <div
      className={cx(
        `relative padding-top-${paddingTop} padding-bottom-${paddingBottom} block-width mxauto flex flex-col items-center justify-center`,
        { guideline: showBlockTitle }
      )}
    >
      {showBlockTitle ? (
        <p className="block-title absolute r0 t0">{title}</p>
      ) : null}
      <div
        className={cx(`image-width-${imageSize}`, {
          [`image-width-${imageSize}-container`]:
            !imageSizeByHeight && imageTextPosition !== 'bottom' && imageText
        })}
      >
        <CaptionImageBlock block={captionImage} />
      </div>
    </div>
  );
};

BlockImage.propTypes = {
  block: PropTypes.shape({
    fields: PropTypes.shape({
      captionImage: PropTypes.shape({
        fields: captionImageBlockModel.propTypes
      }),
      paddingTop: PropTypes.string,
      paddingBottom: PropTypes.string,
      title: PropTypes.string,
      showBlockTitle: PropTypes.bool
    })
  })
};

BlockImage.defaultProps = {
  block: {
    fields: {
      captionImage: {
        fields: captionImageBlockModel.default
      },
      paddingTop: 'Large',
      paddingBottom: 'Large',
      title: '',
      showBlockTitle: false
    }
  }
};

export default BlockImage;
